import React, { useState } from 'react';
import axios from 'axios';

function Login({ onLogin }) {
  const [identifiant, setIdentifiant] = useState('');
  const [password, setPassword]       = useState('');
  const [error, setError]             = useState('');
  const [loading, setLoading]         = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post('/api/auth/login', { identifiant, password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
      onLogin(res.data.user);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* Logo / Titre */}
        <div style={styles.header}>
          <div style={styles.logoCircle}>GM</div>
          <h1 style={styles.title}>Gestion des Marchés</h1>
          <p style={styles.subtitle}>Connectez-vous pour accéder à votre espace</p>
        </div>

        {/* Formulaire */}
        <form onSubmit={handleSubmit} style={styles.form}>
          {error && (
            <div style={styles.errorBanner}>
              <span>⚠️</span> {error}
            </div>
          )}

          <div style={styles.field}>
            <label style={styles.label}>Identifiant</label>
            <input
              style={styles.input}
              type="text"
              value={identifiant}
              onChange={e => setIdentifiant(e.target.value)}
              placeholder="Votre identifiant"
              autoFocus
              required
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Mot de passe</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          <button
            type="submit"
            style={loading ? styles.btnDisabled : styles.btn}
            disabled={loading}
          >
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #2c3e50 0%, #3498db 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
  },
  card: {
    background: '#fff',
    borderRadius: '12px',
    padding: '2.5rem',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  header: {
    textAlign: 'center',
    marginBottom: '2rem',
  },
  logoCircle: {
    width: '64px', height: '64px',
    background: 'linear-gradient(135deg, #2c3e50, #3498db)',
    borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: '#fff', fontSize: '1.4rem', fontWeight: 700,
    margin: '0 auto 1rem',
  },
  title: {
    fontSize: '1.5rem', fontWeight: 700, color: '#2c3e50', margin: '0 0 0.4rem',
  },
  subtitle: {
    color: '#7f8c8d', fontSize: '0.9rem', margin: 0,
  },
  form: { display: 'flex', flexDirection: 'column', gap: '1.25rem' },
  field: { display: 'flex', flexDirection: 'column', gap: '0.4rem' },
  label: { fontSize: '0.875rem', fontWeight: 600, color: '#2c3e50' },
  input: {
    padding: '0.75rem 1rem',
    border: '1px solid #ddd', borderRadius: '6px',
    fontSize: '1rem', outline: 'none',
    transition: 'border-color 0.2s',
  },
  btn: {
    padding: '0.85rem',
    background: 'linear-gradient(135deg, #2c3e50, #3498db)',
    color: '#fff', border: 'none', borderRadius: '6px',
    fontSize: '1rem', fontWeight: 600, cursor: 'pointer',
    marginTop: '0.5rem',
  },
  btnDisabled: {
    padding: '0.85rem',
    background: '#95a5a6',
    color: '#fff', border: 'none', borderRadius: '6px',
    fontSize: '1rem', fontWeight: 600, cursor: 'not-allowed',
    marginTop: '0.5rem',
  },
  errorBanner: {
    background: '#f8d7da', color: '#721c24',
    padding: '0.75rem 1rem', borderRadius: '6px',
    fontSize: '0.875rem', display: 'flex', gap: '0.5rem', alignItems: 'center',
    borderLeft: '4px solid #e74c3c',
  },
};

export default Login;
